import styles from "../../../styles/Login.module.css";
import { formatCPForCNPJInput, formatTelefoneInput } from "../../utils/Utils";
import CustomInput from "../CustomInput";

export default function Step1({ values, handleChange, handleBlur, errors, touched, submitting }) {
    return (
        <div style={{ flex: 1 }}>
            <div className={`${styles.formLogin}`}>
                <CustomInput
                    placeholder="Informe seu nome completo"
                    label="Nome completo"
                    name="cli_nome"
                    value={values.cli_nome}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    errors={errors}
                    touched={touched}
                    disabled={submitting}
                    required
                />

                <CustomInput
                    placeholder="Informe seu CPF/CNPJ"
                    label="CPF/CNPJ" name="cli_cpf_cnpj"
                    value={values.cli_cpf_cnpj}
                    onChange={(e) => handleChange(formatCPForCNPJInput(e))}
                    onBlur={handleBlur} errors={errors}
                    touched={touched} disabled={submitting}
                    maxLength={18}
                    required
                    inputMode="numeric"
                />

                <CustomInput
                    placeholder="Informe seu e-mail"
                    label="E-mail" name="cli_email"
                    value={values.cli_email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    errors={errors}
                    touched={touched}
                    disabled={submitting}
                    required
                    inputMode="email"
                />

                <CustomInput
                    placeholder="Informe seu telefone"
                    label="Telefone"
                    name="cli_telefone"
                    value={values.cli_telefone}
                    onChange={(e) => handleChange(formatTelefoneInput(e))}
                    onBlur={handleBlur}
                    errors={errors}
                    touched={touched}
                    disabled={submitting}
                    maxLength={15}
                    required
                    inputMode="numeric"
                />
            </div>
        </div>
    );
}
